import { z } from 'zod';
import { EmptyObject } from 'libs/end-to-end/src/generic';
import { createCustomVizRequestSchema } from 'libs/end-to-end/src/custom-viz/createCustomVizRequestSchema';

export const NlpGraphInputsExtras = z
  .object({
    query: z.string(),
    yAxisName: z.string(),
    xAxisName: z.string(),
    xAxisElementColumn: z.string(),
    valueColumn: z.string(),
    graphName: z.string(),
  })
  .describe('NlpGraphInputsExtras');

export const NlpGraphInputs = z.object({
  dropdowns: EmptyObject,
  extras: NlpGraphInputsExtras,
});

export type NlpGraphInputs = z.infer<typeof NlpGraphInputs>;

export const NlpGraphRequest = createCustomVizRequestSchema(
  'nlpGraph',
  NlpGraphInputs,
);

export type NlpGraphRequest = z.infer<typeof NlpGraphRequest>;

export const NlpGraphResult = z.object({
  graphName: z.string(),
  xAxisName: z.string(),
  yAxisName: z.string(),
  dataPoints: z.array(
    z.object({
      x: z.number(),
      xName: z.string(),
      y: z.number(),
    }),
  ),
});

export type NlpGraphResult = z.infer<typeof NlpGraphResult>;
